module.exports = "/fast-coin/img/coin/anim/in/coin_in_009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_009.png
// module id = 2279
// module chunks = 5